import { api } from './api'

const API_BASE = `${import.meta.env.VITE_API_URL}/api/v1`

export const pdfServices = {
  generateInvoice: (visitId, visitType) => {
    return api.get(`${API_BASE}/pdf/invoice`, {
      params: { visit_id: visitId, visit_type: visitType },
      responseType: 'blob',
    })
  },

  generatePrescriptionInvoice: (visitId, visitType) => {
    return api.get(`${API_BASE}/pdf/prescription-invocie`, {
      params: { visit_id: visitId, visit_type: visitType },
      responseType: 'blob',
    })
  },
}
